var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "modal-export",
      attrs: {
        show: _vm.show,
        title: _vm.modalTitle,
        saveButton: {
          title: "Exportar",
          btnClass: { "btn btn-main btn-rounded btn-sm z-depth-0": true },
          visible: _vm.visibleExportBtn,
        },
        cancelButton: {
          title: _vm.textCancelBtn,
          btnClass: {
            "btn btn-outline-main btn-rounded btn-outline btn-sm z-depth-0": true,
            disabled: _vm.disabledCancelBtn,
          },
        },
        size: "small",
        needHeader: false,
        relativeBackdrop: true,
        contentCentered: true,
      },
      on: { close: _vm.onCancel, save: _vm.onExportData },
    },
    [
      _c(
        "form",
        {
          staticClass: "dg-form",
          attrs: { autocomplete: "off" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _vm.confirmExport && !_vm.isStartedJob
            ? _c("div", [
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.$t(_vm.confirmMessage)) },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.confirmExport || (_vm.confirmExport && _vm.isStartedJob)
            ? _c("div", [
                _vm.labelText
                  ? _c("label", {
                      attrs: { for: "dg-label" },
                      domProps: { innerHTML: _vm._s(_vm.labelText) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isStartedJob && !_vm.isCompletedJob
                  ? _c("div", { staticClass: "progress" }, [
                      _c(
                        "div",
                        {
                          staticClass: "progress-bar",
                          class: [_vm.progressClasses],
                          style: _vm.styleObject,
                          attrs: {
                            role: "progressbar",
                            "aria-valuenow": _vm.progress.current,
                            "aria-valuemin": _vm.progress.min,
                            "aria-valuemax": _vm.progress.max,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.progressLabel) +
                              "\n                "
                          ),
                        ]
                      ),
                    ])
                  : _c("div", { staticClass: "report-result" }, [
                      _vm.hasUrl
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "btn",
                                class: [_vm.buttonColorClass],
                                attrs: {
                                  href: _vm.urlReport,
                                  role: "button",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t(_vm.downloadReportText)) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasFiles
                        ? _c("div", [
                            _c(
                              "ul",
                              { staticClass: "list-group list-group-flush" },
                              _vm._l(_vm.filesReport, function (file, fIdx) {
                                return _c(
                                  "li",
                                  {
                                    key: `file-${fIdx}`,
                                    staticClass: "list-group-item",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "_blank",
                                          href: file[_vm.propertyFileUrl],
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              file[_vm.propertyFileLabel] ||
                                                _vm.defaultFileName
                                            ) +
                                            "\n                                "
                                        ),
                                        _vm.showIconExport
                                          ? _c("i", {
                                              staticClass: "fas fa-download",
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasErrors
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "alert alert-danger m-0 mt-3 py-2 px-3 small",
                                attrs: { role: "alert" },
                              },
                              _vm._l(_vm.errorsJob, function (error, index) {
                                return _c("p", {
                                  key: index,
                                  staticClass: "pb-0",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.$sanitize(error)),
                                  },
                                })
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }